import type {
  FormInputControl,
  FormFileControl,
  KycPersonalInfoType,
  FormSelectControl,
  FormFullNameControl,
  FormBirthdateConftrol,
  KycPersonalInfoControls,
} from '../../types/form-config';

import { KycProps } from '../../constants/kyc';
import { getFormDataLimit } from '../../utils';

const fullName: FormFullNameControl = {
  tag: 'fullName',
  controls: {
    [KycProps.SALUTAION]: {
      type: 'text',
      name: KycProps.SALUTAION,
      placeholder: 'salutation',
      validator: 'string=true, min=2, max=50',
      tag: 'input',
      label: 'Salutation',
    } as FormInputControl,
    [KycProps.FIRSTNAME]: {
      type: 'text',
      name: KycProps.FIRSTNAME,
      placeholder: 'first name',
      validator: 'string=true, min=2, max=50',
      tag: 'input',
      label: 'First Name',
    } as FormInputControl,
    [KycProps.MIDDLE_NAME]: {
      type: 'text',
      name: KycProps.MIDDLE_NAME,
      placeholder: 'middle name',
      validator: 'string=true, min=2, max=50',
      tag: 'input',
      label: 'Middle Name',
    } as FormInputControl,
    [KycProps.LAST_NAME]: {
      type: 'text',
      name: KycProps.LAST_NAME,
      placeholder: 'last name',
      validator: 'string=true, min=2, max=50',
      tag: 'input',
      label: 'Last Name',
    } as FormInputControl,
  },
};

const gender: FormSelectControl = {
  tag: 'select',
  placeholder: 'gender',
  name: KycProps.GENDER,
  type: 'text',
  label: 'Gender',
  options: [],
  remoteOption: true,
  optionCategory: 'GENDER',
  optionGetter: 'getOptions',
  validator: 'required=true',
};

const birthdate: FormBirthdateConftrol = {
  tag: 'birthdate',
  controls: {
    [KycProps.AGE]: {
      tag: 'input',
      placeholder: 'age',
      name: KycProps.AGE,
      type: 'text',
      label: 'Age (year)',
    },
    [KycProps.BIRTH_DATE]: {
      tag: 'input',
      placeholder: 'birth date',
      name: KycProps.BIRTH_DATE,
      type: 'date',
      label: 'Birth Date',
      validator: 'required=true',
    },
  },
};

const birthPlace: FormInputControl = {
  tag: 'input',
  placeholder: 'birth place',
  name: KycProps.BIRTH_PLACE,
  type: 'text',
  label: 'Birth Place',
  validator: 'required=true, string=true, min=2, max=50',
};

const occupation: FormSelectControl = {
  tag: 'select',
  placeholder: 'occupation',
  name: KycProps.OCCUPATION,
  type: 'text',
  label: 'Occupation',
  options: [],
  remoteOption: true,
  optionCategory: 'OCCUPATION',
  optionGetter: 'getOptions',
  validator: 'required=true',
};
const taxId: FormInputControl = {
  tag: 'input',
  placeholder: 'tax id',
  name: KycProps.TAX_ID,
  type: 'text',
  label: "Taxpayer's Identification Number",
  validator: 'required=true, string=true, tin=true',
};

const nationality: FormSelectControl = {
  tag: 'select',
  placeholder: 'nationality',
  name: KycProps.NATIONALITY,
  type: 'text',
  label: 'Nationality',
  remoteOption: true,
  validator: 'required=true',

  // optionCategory: 'CITIZENSHIP',
  // optionGetter: 'getOptions',

  optionCategory: 'COUNTRY',
  optionGetter: 'getOptionsAddress',
};

const socialSecurity: FormInputControl = {
  tag: 'input',
  placeholder: 'ssss/ gsis',
  name: KycProps.SSS,
  type: 'text',
  label: 'SSS/GSIS Number',
};

const id_type: FormSelectControl = {
  tag: 'select',
  placeholder: 'ID type',
  name: KycProps.ID_TYPE,
  type: 'text',
  label: 'Government ID Type',
  options: [],
  validator: 'required=true',
  remoteOption: true,
  optionCategory: 'ID_TYPE',
  optionGetter: 'getOptions',
};

const id_number: FormInputControl = {
  tag: 'input',
  placeholder: 'ID number',
  name: KycProps.ID_NUMBER,
  type: 'text',
  label: 'Government ID Number',
  validator: 'required=true, min=2, max=50',
};

const DocType01: FormFileControl = {
  tag: 'file',
  placeholder: 'scan photo id',
  tooltip: ` Please upload a photograph of the front of this ID that clearly shows the number and expiry date (if any). You will need to present this ID to an agent at a face to face meeting (to be scheduled after filling out this form). You may also present your Unified Multi-Purpose ID Card instead of your SSS, GSIS, Philhealth, or Pag-ibig ID. `,
  name: KycProps.DOCTYPE_1,
  type: 'file',
  label: 'Scan/Photo ID',
  validator: 'required=true',
};
const DocType03: FormFileControl = {
  tag: 'file',
  placeholder: 'scan photo signature',
  tooltip:
    'Please upload a photograph of your signature made on a piece of paper. ',
  name: KycProps.DOCTYPE_3,
  type: 'file',
  label: 'Scan/Signature ID',
  validator: 'required=true',
};

const spouseName: FormInputControl = {
  tag: 'input',
  placeholder: 'spouse name',
  name: KycProps.SPOUSE_NAME,
  type: 'text',
  label: 'Spouse Name',
};

const civilStatus: FormSelectControl = {
  tag: 'select',
  placeholder: 'civil status',
  name: KycProps.CIVIL_STATUS,
  type: 'text',
  label: 'Civil Status',
  options: [],
  validator: 'required=true',
  remoteOption: true,
  optionCategory: 'MARITAL_STATUS',
  optionGetter: 'getOptions',
};

const totalChildren: FormInputControl = {
  tag: 'input',
  placeholder: 'number of children',
  name: KycProps.TOTAL_CHILDREN,
  type: 'text',
  validator: 'number=true',
  label: 'Number of Children',
};

const controls: KycPersonalInfoControls = [
  fullName,
  gender,
  birthdate,
  birthPlace,
  occupation,
  nationality,
  taxId,
  socialSecurity,
  id_type,
  id_number,
  DocType01,
  DocType03,
  civilStatus,
  spouseName,
  totalChildren,
];

const KycPersonalInfoData: KycPersonalInfoType = {
  name: 'personal_info',
  display: 'Personal Info',
  files: [KycProps.DOCTYPE_1, KycProps.DOCTYPE_3],
  controls,
  getFormData: getFormDataLimit(controls),
};

export default KycPersonalInfoData;
